// $('#shopify-section-template--18333280272578__index_categories_slider_GeNJB6').css('background','blue');

// SLIDER EN CATEGORIAS
document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.swiper-container-subcategorias');

  if (!container) return; // 👈 si no existe, no inicializa

  const swiper = new Swiper(container, {
    loop: true,
    spaceBetween: 10,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    wrapperClass: 'swiper-wrapper-subcategorias',
    slideClass: 'swiper-slide-subcategorias',
    slidesPerGroup: 1,

    breakpoints: {
      0: { slidesPerView: 2 },
      768: { slidesPerView: 4 },
      1024: { slidesPerView: 7 }
    }
  });

  swiper.autoplay.start();
});
// END SLIDER EN CATEGORIAS //



// SLIDER DE COMPLETA TU COMPRA
document.addEventListener("DOMContentLoaded", function () {
    const container = document.querySelector(".product-container");
    const leftBtn = document.querySelector(".left-btn");
    const rightBtn = document.querySelector(".right-btn");

    if (container && leftBtn && rightBtn) {
        const productWidth = container.querySelector(".product-item").offsetWidth;

        function checkButtons() {
            leftBtn.style.display = container.scrollLeft > 0 ? "block" : "none";
            rightBtn.style.display = container.scrollLeft < (container.scrollWidth - container.clientWidth) ? "block" : "none";
        }

        leftBtn.addEventListener("click", function () {
            container.scrollBy({ left: -productWidth * 2, behavior: "smooth" });
        });

        rightBtn.addEventListener("click", function () {
            container.scrollBy({ left: productWidth * 2, behavior: "smooth" });
        });

        container.addEventListener("scroll", checkButtons);
        window.addEventListener("resize", checkButtons);
        checkButtons();
    }
});

document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".product-container");
  const dotsWrap  = document.querySelector(".pagination-dots");
  const items     = Array.from(document.querySelectorAll(".product-item"));

  if (!container || !dotsWrap || items.length === 0) return;

  const MAX_DOTS = 3;
  let dots = [];
  let slideOffsets = [];
  let totalSlides = 0;
  let animating = false;

  // Siempre 2 ítems por dot
  function buildOffsets() {
    slideOffsets = [];
    const perView = 2; 
    const baseLeft = (items[0]?.offsetLeft || 0);

    for (let s = 0; s * perView < items.length; s++) {
      const idx = s * perView;
      const child = items[idx];
      const off = (child.offsetLeft - baseLeft);
      slideOffsets.push(off);
    }
  }

  function buildDots() {
    dotsWrap.innerHTML = "";
    buildOffsets();
    totalSlides = slideOffsets.length;

    const dotsToShow = Math.min(totalSlides, MAX_DOTS);

    for (let i = 0; i < dotsToShow; i++) {
      const dot = document.createElement("div");
      dot.classList.add("dot");
      if (i === 0) dot.classList.add("active");
      dot.addEventListener("click", () => goToSlide(i));
      dotsWrap.appendChild(dot);
      dots.push(dot);
    }
  }

  function goToSlide(i) {
    if (animating) return;
    animating = true;
    container.scrollTo({ left: slideOffsets[i], behavior: "smooth" });

    dots.forEach((dot, idx) => {
      dot.classList.toggle("active", idx === i);
    });

    setTimeout(() => { animating = false; }, 500);
  }

  buildDots();
  window.addEventListener("resize", buildDots);
});


// END SLIDER DE COMPLETA TU COMPRA


//IMAGEN Y BOTON DEL FOOTER - COLUMNA 3 -
document.addEventListener("DOMContentLoaded", function () {
  // Crea el bloque (imagen + botón)
  function crearBloque() {
    var contenedor = document.createElement("div");
    contenedor.className = "bloque-catalogo";
    contenedor.style.textAlign = "center";
    contenedor.style.marginTop = "15px";

    var img = document.createElement("img");
    img.src = "https://cdn.shopify.com/s/files/1/0649/7366/8546/files/img-catalogo.png?v=1746458255";
    img.alt = "Catálogo";
    img.style.maxWidth = "180px";
    img.style.display = "block";
    img.style.margin = "0 auto 10px";

    var boton = document.createElement("a");
    boton.href = "https://uk3mgj-4e.myshopify.com/pages/mayoristas-1";
    boton.textContent = "VENDER AHORA";
    boton.style.display = "inline-block";
    boton.style.padding = "10px 20px";
    boton.style.backgroundColor = "#e6cbb2";
    boton.style.color = "#fff";
    boton.style.textDecoration = "none";
    boton.style.fontWeight = "bold";
    boton.style.borderRadius = "4px";

    contenedor.appendChild(img);
    contenedor.appendChild(boton);

    return contenedor;
  }

  // Palabras clave para identificar la columna objetivo (ajusta si quieres otro texto)
  var keywords = ["VENDE", "VENDER", "CATALOG", "CATÁLOGO", "AUMENTA", "INGRESOS"];

  // Inserta el bloque en la/s columnas que coincidan con las keywords
  function insertarEnLinklists() {
    var linklists = document.querySelectorAll(".footer__linklist");
    if (!linklists || linklists.length === 0) return;

    linklists.forEach(function (link) {
      // Texto disponible en móvil (accordion) o en desktop (heading)
      var mobileTitleEl = link.querySelector(".accordion__title");
      var desktopHeadingEl = link.querySelector(".footer-block__heading");
      var headingText = "";

      if (mobileTitleEl) headingText = mobileTitleEl.textContent.trim();
      if (!headingText && desktopHeadingEl) headingText = desktopHeadingEl.textContent.trim();

      if (!headingText) return;

      var headingUpper = headingText.toUpperCase();
      var esCoincidente = keywords.some(function (k) { return headingUpper.includes(k.toUpperCase()); });

      if (!esCoincidente) return;

      // --- Móvil: insertar dentro de la sección accordion (pero fuera de accordion__content)
      var accordionContainer = link.querySelector(".footer__linklist-accordion");
      if (accordionContainer && !accordionContainer.querySelector(".bloque-catalogo")) {
        var titleEl = accordionContainer.querySelector(".accordion__title");
        if (titleEl) {
          var nuevo = crearBloque();
          // insertar justo después del título (antes del accordion__content) para que sea visible aunque esté colapsado
          var siguiente = titleEl.nextElementSibling;
          if (siguiente) titleEl.parentNode.insertBefore(nuevo, siguiente);
          else titleEl.parentNode.appendChild(nuevo);
        } else {
          // fallback: si no hay title, añadir al final del accordionContainer
          accordionContainer.appendChild(crearBloque());
        }
      }

      // --- Desktop: insertar en la versión desktop de la columna
      var menuDesktop = link.querySelector(".footer__linklist-menu");
      if (menuDesktop) {
        var desktopContent = menuDesktop.querySelector(".footer-block__details-content-desktop.row");
        if (desktopContent && !desktopContent.querySelector(".bloque-catalogo")) {
          desktopContent.appendChild(crearBloque());
        }
      }
    });
  }

  // Ejecutar una vez al cargar
  insertarEnLinklists();

  // Observar cambios (por si el tema re-renderiza el footer dinámicamente)
  var footerMain = document.querySelector(".footer-main__content") || document.querySelector("footer");
  if (footerMain) {
    var debounce;
    var observer = new MutationObserver(function () {
      clearTimeout(debounce);
      debounce = setTimeout(function () {
        insertarEnLinklists();
      }, 100);
    });
    observer.observe(footerMain, { childList: true, subtree: true, attributes: true });
  }
});
//END IMAGEN Y BOTON DEL FOOTER - COLUMNA 3 -


//TRADUCCIONES

  $(document).ready(function() {
    console.log("Script ejecutado");
    
    const observer = new MutationObserver(() => {
      const $feedback = $('#shipping-rates-feedback');
      if ($feedback.length) {
        console.log("Elemento encontrado:", $feedback.text());
        
        const textoOriginal = 'There is one shipping rate available for';
        const textoTraducido = 'Hay una tarifa de envío disponible para';

      const contenido = $feedback.html();
        if (contenido.includes(textoOriginal)) {
          $feedback.html(contenido.replace(textoOriginal, textoTraducido));
          observer.disconnect();
          console.log("Traducción aplicada");
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });

   $(document).ready(function() {
    console.log("Script ejecutado");
    
    const observer = new MutationObserver(() => {
      const $feedback = $('.cart-modal__upsell-title');
      if ($feedback.length) {
        console.log("Elemento encontrado:", $feedback.text());
        
        const textoOriginal = 'Other customers also bought';
        const textoTraducido = 'Otros clientes también compraron';

      const contenido = $feedback.html();
        if (contenido.includes(textoOriginal)) {
          $feedback.html(contenido.replace(textoOriginal, textoTraducido));
          observer.disconnect();
          console.log("Traducción aplicada");
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });



 





